var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-loader"},[_c('div',{attrs:{"id":"loader2"}}),_c('div',{staticClass:"cssload-dots"},[_c('div',{staticClass:"cssload-dot"}),_c('div',{staticClass:"cssload-dot"}),_c('div',{staticClass:"cssload-dot"}),_c('div',{staticClass:"cssload-dot"}),_c('div',{staticClass:"cssload-dot"})])])
}]

export { render, staticRenderFns }